<template>
  <v-card :loading="isFindConfigurationPending || isFindCustomPromptsPending || requirementsSaving">
    <v-btn
      absolute
      right
      fab
      dark
      small
      color="grey darken-3"
      class="mt-4"
      title="Order registration prompts"
      @click="oderRegistrationPrompts = true"
    >
      <v-icon>mdi-format-list-numbered</v-icon>
    </v-btn>
    <PromptOrder
      v-model="registrationPrompts"
      :open.sync="oderRegistrationPrompts"
      :set-callback="savePrompts"
      :enforced-prompt-order.sync="enforcedPromptOrder"
      v-if="registrationPrompts"
    ></PromptOrder>
    <v-card-title>
      <h1 class="headline">Registration Prompts</h1>
    </v-card-title>
    <v-card-subtitle>
      <h2
        class="subtitle-1"
      >Choose what information is prompted when a person registers with the bot.</h2>
    </v-card-subtitle>
    <v-card-text v-if="enabledFeatures && enabledFeatures.config">
      <p>
        Telegram users can send the
        <v-chip color="accent" class="mx-1">/register</v-chip>command to your bot to register.
      </p>

      <v-row
        v-if="enabledFeatures && enabledFeatures.config && enabledFeatures.config.registration"
      >
        <v-col
          v-for="(chunk, index) in promptChunks(prompts, chunkSize)"
          :key="index"
          class="px-4 py-0"
          cols="12"
          md="6"
        >
          <div v-if="registrationPrompts">
            <v-checkbox
              v-for="prompt in chunk"
              v-model="registrationPrompts.config"
              :key="prompt.step"
              :value="prompt.step"
              :label="prompt.name"
              :hint="prompt.hint"
              :disabled="prompt.disabled"
              :readonly="prompt.readonly"
              :persistent-hint="prompt.persistentHint"
              hide-details="auto"
              color="accent"
            ></v-checkbox>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mt-4 mb-0" cols="8">
          <p>
            Want custom registration prompts? You can add a special
            <router-link
              :to="{name: 'elaborators', params: {custom:true}}"
            >custom registration prompts</router-link>elaborator.
          </p>
        </v-col>
        <v-col
          class="mt-4 mb-0"
          cols="4"
          align="end"
          v-if="enabledFeatures && enabledFeatures.config && enabledFeatures.config.registration"
        >
          <v-btn
            class="mt-2 mr-2"
            color="primary"
            outlined
            @click="savePrompts()"
            :loading="requirementsSaving"
          >Save</v-btn>
        </v-col>
      </v-row>

      <v-row
        v-if="enabledFeatures && enabledFeatures.config && enabledFeatures.config.registration"
      >
        <v-col cols="12" class="py-2" v-if="registrationRules">
          <h2 class="title ml-4">Registration Rules</h2>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="6" v-if="registrationRules">
          <v-switch
            v-model="registrationRules.config.denyIfNoGroups"
            @change="saveRules()"
            inset
            class="px-4"
            label="Deny If No Allowed Groups"
            :hint="registrationRules.config.denyIfNoGroups ? 'Registration will be denied if the member does not qualify for inclusion in any of your groups.':'Registration will be allowed even if the member does not qualify for inclusion in any of your groups.'"
            :persistent-hint="true"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" v-if="registrationRules">
          <v-switch
            v-model="registrationRules.config.bypassRestrictRegistration"
            @change="saveRules()"
            inset
            class="px-4"
            label="Bypass Registration For Restrict File"
            :hint="!registrationRules.config.bypassRestrictRegistration ? 'Restrict file users will still need to complete the full registration process.':'Restrict file users will only be required to send their contact card.'"
            :persistent-hint="true"
          ></v-switch>
        </v-col>
        <!--<v-col cols="12" md="6" v-if="registrationRules">
          <v-switch
            v-model="registrationRules.config.membersMustBeVerified"
            @change="saveRules()"
            inset
            class="px-4"
            label="Members Must Be Verified"
            :hint="!registrationRules.config.membersMustBeVerified ? 'Once registered, members can use member functionality.':'Once registered, members must first be verified before they can use member functinality functionality.'"
            :persistent-hint="true"
          ></v-switch>
        </v-col>-->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { makeFindMixin } from "feathers-vuex";
import { mapGetters, mapActions } from "vuex";
import PromptOrder from "@/components/widget/PromptOrder";

export default {
  components: {
    PromptOrder,
  },
  data: () => ({
    requirementsSaving: false,
    oderRegistrationPrompts: false,
    chunkSize: 4,
    prompts: [
      {
        name: "First name",
        step: "first_name",
      },
      { name: "Last name", step: "last_name" },
      {
        name: "Contact",
        step: "contact",
        hint:
          "Requests user to send their own contact card (this is required and cannot be disabled)",
        readonly: true,
        persistentHint: true,
      },
      { name: "Email", step: "email" },
      { name: "Physical address", step: "physical_address" },
      {
        name: "Postal address",
        step: "postal_address",
      },
      {
        name: "Location",
        step: "location",
        hint: "Request the user's GPS location",
        persistentHint: true,
      },
      { name: "ID/Passport number", step: "id_passport_number" },
    ],
  }),
  mixins: [
    makeFindMixin({ service: "configuration" }),
    makeFindMixin({ service: "elaborators", name: "customPrompts" }),
  ],
  async mounted() {},
  computed: {
    ...mapGetters("config", ["registerHasGeofence"]),
    configurationParams() {
      return {
        query: {},
      };
    },
    customPromptsParams() {
      return {
        query: {
          $modify: "customPrompts",
        },
      };
    },
    enabledFeatures() {
      return this.configuration.find(
        (config) => config.id === "enabledFeatures"
      );
    },
    registrationPrompts() {
      return this.configuration.find(
        (config) => config.id === "registrationPrompts"
      );
    },
    customRegistrationPrompts() {
      return (
        this.customPrompts &&
        this.customPrompts.length &&
        this.customPrompts[0].scenes.map((scene) => scene.id)
      );
    },
    registrationRules() {
      return this.configuration.find(
        (config) => config.id === "registrationRules"
      );
    },
    enforcedPromptOrder() {
      return this.registrationRules &&
        this.registrationRules.config &&
        this.registrationRules.config.bypassRestrictRegistration
        ? [{ prompt: "contact", index: 0 }]
        : [];
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async savePrompts() {
      this.requirementsSaving = true;
      await this.registrationPrompts.save();
      this.showMessage({ text: "Configuration saved!", color: "green" });
      this.requirementsSaving = false;
    },
    async saveRules() {
      this.requirementsSaving = true;
      await this.registrationRules.save();
      this.showMessage({ text: "Rules saved!", color: "green" });
      this.requirementsSaving = false;
    },
    async setLocationRequired(isRequired) {
      this.requirementsSaving = true;
      if (
        isRequired &&
        this.registrationPrompts &&
        this.registrationPrompts.config &&
        !this.registrationPrompts.config.includes("location")
      ) {
        this.registrationPrompts.config.push("location");
        await this.savePrompts();
      }

      this.prompts.forEach((prompt) => {
        if (prompt.step === "location") {
          prompt.readonly = !!isRequired;
          prompt.hint = isRequired
            ? "Request the user's GPS location (must be enabled if using geofencing)"
            : "Request the user's GPS location";
        }
      });
      this.requirementsSaving = false;
    },
    promptChunks(array, chunk_size) {
      return Array(Math.ceil(array.length / chunk_size))
        .fill()
        .map((_, index) => index * chunk_size)
        .map((begin) => array.slice(begin, begin + chunk_size));
    },
  },
  watch: {
    registerHasGeofence(hasGeofence) {
      this.setLocationRequired(hasGeofence);
    },
    customRegistrationPrompts(custom) {
      if (this.registrationPrompts && custom && custom.length) {
        this.registrationPrompts.config = this.registrationPrompts.config.concat(
          custom.filter(
            (value) => !this.registrationPrompts.config.includes(value)
          )
        );
      }
    },
  },
  props: {
    /*configuration: {
      type: Array,
      default: () => {
        return [];
      },
    },*/
  },
};
</script>